import Header from 'accounts/components/list/AccountsListHeader';
import Filters from 'accounts/components/list/AccountsListFilters';
import Table from 'accounts/components/list/AccountsListTable';
import Row from 'accounts/components/list/AccountsListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/index.js